export const permissionSetsApiHandler = {
  permissionsSystemCopy: {
    permissionContexts: {
      getAllPermissionContexts: {
        method: "GET",
        path: () => `permission-contexts`
      }
    },
    permissionCategories: {
      getAllPermissionCategories: {
        method: "GET",
        path: () => `permission-categories`
      }
    },
    permissionSets: {
      getAllPermissionSets: {
        method: "GET",
        path: () => `permission-sets`,
        params: {} as {'skip'?: string | number, 'take'?: string | number, 'contexts'?: (string | number)[], 'organizationIds'?: (string | number)[]}
      },
      getSinglePermissionSet: {
        method: "GET",
        path: (payload: { permissionSetId: string | number }) => `permission-sets/${payload.permissionSetId}`
      },
      updatePermissionSet: {
        method: "PATCH",
        path: (payload: { permissionSetId: string | number }) => `permission-sets/${payload.permissionSetId}`
      },
      updatePermissionSetByAdmin: {
        method: "PATCH",
        path: (payload: { permissionSetId: string | number }) => `permission-sets/${payload.permissionSetId}/admin`
      }
    },
    permissions: {
      getAllPermissions: {
        method: "GET",
        path: () => `permissions`,
        params: {} as {'skip'?: string | number, 'take'?: string | number, 'contexts'?: (string | number)[], 'categories'?: (string | number)[], 'contextSlugs'?: (string | number)[]}
      }
    },
    testingPermissions: {
      newRequest: {
        method: "GET",
        path: (payload: { slug: string | number }) => `testing-permissions/${payload.slug}`
      }
    }
  },
  getAllOrgPermissionSets: {
    method: "GET",
    path: () => `org-permissions-management`,
    params: {} as {'skip'?: string | number, 'take'?: string | number, 'contextSlugs'?: (string | number)[]}
  },
  createOrgPermissionSet: {
    method: "POST",
    path: () => `org-permissions-management`
  },
  getSingleOrgPermissionSet: {
    method: "GET",
    path: (payload: { orgPermissionSetId: string | number }) => `org-permissions-management/${payload.orgPermissionSetId}`
  },
  updateOrgPermissionSet: {
    method: "PATCH",
    path: (payload: { orgPermissionSetId: string | number }) => `org-permissions-management/${payload.orgPermissionSetId}`
  },
  deleteOrgPermissionSet: {
    method: "DELETE",
    path: (payload: { orgPermissionSetId: string | number }) => `org-permissions-management/${payload.orgPermissionSetId}`
  },
  // Platform admins
  getPlatformUsers: {
    method: "GET",
    path: () => `platform-admins/users`,
    params: {} as { skip?: number, take?: number, search?: string, platformAdminsOnly?: string }
  },
  updateUserPermissionSet: {
    method: "PATCH",
    path: (payload: { userId: string | number }) => `platform-admins/users/${payload.userId}/permission-set`
  },
  getUserPermissionSets: {
    method: "GET",
    path: () => `platform-admins/permission-sets`
  },
  createUserPermissionSet: {
    method: "POST",
    path: () => `platform-admins/permission-sets`
  },
  deleteUserPermissionSet: {
    method: "DELETE",
    path: (payload: { id: string | number }) => `platform-admins/permission-sets/${payload.id}`
  }
};